<template>
  <div>
    <div class="page-header">
      <div class="container-fluid d-flex align-items-center justify-content-between">
       <h2 class="h4 no-margin-bottom">Servis Detay</h2>
       <div class="right-menu list-inline no-margin-bottom">
          <div v-if="posts.sdid===2">
           <button v-if="ayar.ya === 'bid'" class="btn btn-light" @click="baslat()">Servis Başlat</button>
          </div>
           <button v-if="ayar.ya === 'bid' && posts.sdid===3" class="btn btn-light" @click="tamamla('0','0','Başarılı olarak ')">Başarılı Kapat</button>
           <button v-if="ayar.ya === 'bid' && posts.sdid===3" class="btn btn-warning" @click="tamamla('1','0','İptal olarak ')">İptal Et</button>
           <button v-if="ayar.ya === 'bid' && posts.sdid===3" class="btn btn-success" @click="tamamla('0','1','Değişim olarak ')">Değişim</button>
             
           <button v-if="posts.sdid===4" class="btn btn-outline-info ml-3">Servis Tamamlanmış</button>
       </div>
      </div>
    </div>
    <section class="no-padding-top no-padding-bottom">
      <div class="container-fluid">
        <div class="row">
            <div class="col-12 col-lg-9">
            <div v-if="sayfa===1">
              <div class="row block">
                <div class="col-lg-3 col-12">
                  <label class="form-control-label">Servis No</label>
                  <input disabled type="text" class="form-control" :value="posts.no">
                </div>
                <div class="col-lg-3 col-12">
                  <label class="form-control-label">Sağlayıcı</label>
                  <input disabled type="text" class="form-control" :value="posts.sa">
                </div>
                <div class="col-lg-3 col-12">
                  <label class="form-control-label dashtext-2">Servis Tipi</label>
                  <input disabled type="text" class="form-control" :value="posts.st">
                </div>
                <div class="col-lg-3 col-12">
                  <label class="form-control-label">Servis Nedeni</label>
                  <input disabled type="text" class="form-control" :value="posts.sn">
                </div>                

              </div>
              <div class="row block mt-1">
                <div class="col-lg-3 col-12">
                  <label class="form-control-label">Çağrı Tarihi</label>
                  <input disabled type="text" class="form-control" :value="$helper.trtgoster(posts.tarih)">
                </div>
                <div class="col-lg-3 col-12">
                  <label class="form-control-label">Çağrı Saati</label>
                  <input disabled type="text" class="form-control" :value="posts.saat">
                </div>
                <div class="col-lg-3 col-12">
                  <label class="form-control-label">Son işlem {{$helper.trtgoster(posts.ptarih)}}</label>
                  <input type="date" class="form-control" v-model="posts.ptarih">
                </div>
                <div class="col-lg-3 col-12">
                  <label class="form-control-label">Son işlem saati</label>
                  <input type="text" class="form-control"  @keyup="onKeyup"  v-model="posts.psaat">
                </div>

              </div>
              <div class="row block mt-1">
                <div class="col-lg-3 col-12">
                  <label class="form-control-label">Cihaz Grup</label>
                  <input disabled type="text" class="form-control" :value="posts.cname">
                </div>
                <div class="col-lg-3 col-12">
                  <label class="form-control-label">Cihaz Model</label>
                  <input disabled type="text" class="form-control" :value="posts.model">
                </div>
                <div class="col-lg-3 col-12">
                  <label class="form-control-label">Cihaz Barkod</label>
                  <input disabled type="text" class="form-control" :value="posts.barkod">
                </div>
                <div class="col-lg-3 col-12">
                  <label class="form-control-label">Depo</label>
                  <input disabled type="text" class="form-control" :value="posts.depo_kod">
                </div>                
              </div>
              <div class="row block">
                <div class="col-12">
                  <textarea class="form-control" v-model="posts.servis_notu" cols="30" rows="3">
                    {{posts.servis_notu}}
                  </textarea>
                </div>
              </div>
            </div>

            <div v-if="sayfa===2">
              <div class="row block">
                <div class="col-lg-2 col-12">
                  <label class="form-control-label">Cari Kod</label>
                  <input disabled type="text" class="form-control" :value="cari.kodu">
                </div>
                <div class="col-lg-4 col-12">
                  <label class="form-control-label">Cari Ad</label>
                  <input disabled type="text" class="form-control" :value="cari.alias">
                </div>
                <div class="col-lg-3 col-12">
                  <label class="form-control-label">İl</label>
                  <input disabled type="text" class="form-control" :value="cari.il">
                </div>
                <div class="col-lg-3 col-12">
                  <label class="form-control-label">İlçe</label>
                  <input disabled type="text" class="form-control" :value="cari.ilce">
                </div>
                <div class="col-lg-6 col-12 mt-4">
                  <label class="form-control-label">Adres</label>
                  <input disabled type="text" class="form-control" :value="cari.adres">
                </div>                
                <div class="col-lg-3 col-12 mt-4">
                  <label class="form-control-label">Enlem</label>
                  <input disabled type="text" class="form-control" :value="cari.enlem">
                </div>
                <div class="col-lg-3 col-12 mt-4">
                  <label class="form-control-label">Boylam</label>
                  <input disabled type="text" class="form-control" :value="cari.boylam">
                </div>                

              </div>
            </div>

              <div class="row" v-if="sayfa===3">
                <div class="col-12">
                  <div class="row">
                    <div class="table-responsive pr-2">
                        <table class="table table-striped block">

                            <thead>
                              <tr>
                                <th>Kod</th>
                                <th>Malzeme</th>
                                <th>Depo</th>
                                <th class="dashtext-3">Adet</th>
                                <th>Kullanıcı</th>
                                <th>Sil</th>
                              </tr>
                            </thead>

                            <tbody>
                              <tr v-for="post in malzeme" :key="post.id">
                                <td>{{post.stid}}</td>
                                <td>{{post.isim}}</td>
                                <td>{{post.depo}}</td>
                                <td class="dashtext-3">{{post.adet}} Adet</td>
                                <td>{{post.isim2}}</td>
                                <td><i @click="kaldir(post.id,post.adet,post.isim)" class="fa fa-trash fa-lg"></i></td>
                              </tr>
                            </tbody>
                          </table>
                    </div>
                  </div>

                 <div v-if="ayar.ya === 'bid'" class="row mt-3">
                   <div class="col-3">

                        <!-- <label class="form-control-label">Depo Seçimi</label> -->
                         <select @change="deposec($event,true)" class="form-control">
                           <option selected>{{newpost.depo}}</option>
                         <option v-for="(depos,index) in depo" :key="index" 
                         :value="depos.dep_no+'#'+depos.dep_adi">{{depos.dep_adi}}</option>
                      </select>

                   </div>
                   <div class="col-9">
                     <!-- <label class="form-control-label">Depo içinde arama yapın</label> -->
                     <input id="arama" type="text" :placeholder="newpost.depo+' içinde arama yapın'" class="form-control" @keyup="this.$helper.tabloarama">
                   </div>
                 </div>

                  <div v-if="ayar.ya === 'bid'" class="row mt-3">
                    <div class="col-12">
                    <div class="table-responsive pr-2">
                        <table id="tablo" class="table table-striped block">
                            <thead>
                              <tr>
                                <th>Kod</th>
                                <th>İsim</th>
                                <th>Adet</th>
                                <th>Fiyat</th>
                                <th style="width:15%">Adet</th>
                                <th>Ekle</th>
                              </tr>
                            </thead>

                            <tbody>
                              <tr v-for="(post,index) in list" :key="index">
                                <td>{{post.sto_kod}}</td>
                                <td>{{post.sto_isim}}</td>
                                <td class="dashtext-3">{{post.adet}}</td>
                                <td>{{$helper.parabirimi(post.fiyat)}}</td>
                                <td><input v-model="post.adet2"  class="w-50 form-control"></td>
                                <td><i @click="ekle(index)" class="fa fa-plus fa-lg"></i></td>
                              </tr>
                            </tbody>
                          </table>
                    </div>
                  </div>
                  </div>

                </div>
              </div>
              <div class="row" v-if="sayfa===4">
                  <div class="table-responsive">
                      <table class="table table-striped">

                          <thead>
                            <tr>
                              <th>#</th>
                              <th>Yetkisi</th>
                              <th>Ad - Soyad</th>
                              <th>Telefon</th>
                              <th>E-Posta</th>
                            </tr>
                          </thead>

                          <tbody>
                            <tr v-for="(post,index) in kullanici" :key="post.id">
                              <td>{{index+1}}</td>
                              <td>{{post.alias}}</td>
                              <td>{{post.isim}}</td>
                              <td>{{post.tel}}</td>
                              <td>{{post.eposta}}</td>
                            </tr>
                          </tbody>
                        </table>
                  </div>
              </div>
              <div class="row" v-if="sayfa===5">
                <div class="col-12">
                  <ul>
                    <li class="d-inline-block m-2" v-for="(img,index) in imageList" :key="index">
                      <a :href="img.urlsi" target="blank"><img width="140px"  class="img-thumbnail" :src="img.urlsi"></a>
                      <span @click="evraksil(img.id)"  class="d-block text-center dashtext-3 mt-3">Sil</span>
                    </li>
                    <input v-if="ayar.ya === 'bid'" type="file" @change="previewFiles">
                  </ul>
                </div>
              </div>
              <div class="row" v-if="sayfa===6">
                  <div class="table-responsive">
                      <table id="tablo" class="table table-striped">

                          <thead>
                            <tr>
                              <th>Tarih</th>
                              <th>Saat</th>
                              <th>Kullanıcı</th>
                              <th>İşlem</th>
                              <th>Enlem</th>
                              <th>Boylam</th>
                              <th></th>
                            </tr>
                          </thead>

                          <tbody>
                            <tr v-for="post in log" :key="post.id">
                              <td>{{$helper.trtgoster(post.tarih)}}</td>
                              <td>{{post.saat}}</td>
                              <td>{{post.ad_soyad}}</td>
                              <td>{{post.islem}}</td>
                              <td>{{post.enlem}}</td>
                              <td>{{post.boylam}}</td>
                              <th><i v-if="post.kod ===3"  class="fa fa-refresh dashtext-3"></i></th>
                            </tr>
                          </tbody>

                        </table>
                </div>
                <div class="container">
                  <div class="row block" style="color:#000">
                    <div class="col-3 bg-danger"> <i class="fa fa-map-marker ml"></i> Müşteri Merkezi</div>
                    <div class="col-3 bg-success"><i class="fa fa-map-marker ml"></i> Servis Başlatıldı</div>
                    <div class="col-3 bg-warning"><i class="fa fa-map-marker ml"></i> Servis Tamamlandı</div>
                    <div class="col-3 bg-info"><i class="fa fa-map-marker ml"></i> Servis işlemleri</div>
                    <p class="text-light mt-2">Müşteri merkezi konumu bilinmiyor ise servis başlangıcı müşteri merkez konumu olarak atanır.</p>
                  </div>
                  <div class="row">
                    <div class="col-12">
                    <!-- :label = "m.label" -->
                      <gmap-map v-if="harita"
                        :center="center"
                        :zoom="16"
                        style="width: 100%; height: 400px;"
                      >
                        <gmap-marker
                          :key="index"
                          v-for="(m, index) in markers"
                          :position="m.position"
                          :icon="m.icon"
                          :clickable="false"
                          :draggable="false"
                          @click="center=m.position"
                        >
                        </gmap-marker>

                      </gmap-map>
                    </div>
                  </div>
                </div>
                <div v-if="kisa === 'beverage' && ayar.ya === 'bid'"  class="container mt-3">
                  <div class="row">
                    <div class="col-4"><input v-model="logus.tarih" type="date" class="form-control"></div>
                    <div class="col-4"><input v-model="logus.saat" type="time" class="form-control"></div>
                    <div class="col-4"><button @click="baslangicsaati()" class="btn btn-danger btn-sm">Değiştir</button></div>
                  </div>
                </div>
                
              </div>

            </div>
            <div class="col-12 col-lg-3 block">
              <button class="btn btn-outline-info w-100" @click="sayfa=1">Genel Bilgiler</button>
              <button class="btn btn-outline-info w-100 mt-2" @click="sayfa=2">Cari Bilgileri</button>
              <button class="btn btn-outline-info w-100 mt-2" @click="depogetir">Malzeme Tüketimi</button>
              <button class="btn btn-outline-info w-100 mt-2" @click="sayfa=4">Servis Kullanıcıları</button>
              <button class="btn btn-outline-info w-100 mt-2" @click="sayfa=5">İlişik Evraklar</button>
              <button class="btn btn-outline-info w-100 mt-2" @click="sayfa=6">Log Kayıtları</button>
              <hr> 

              <div v-for="items in funcs" :key="items.id">
                <router-link class="w-100" v-if="posts.stid==3 && posts.onay===0 && posts.sdid===4" :to="items.rote + `${sid*8589}`">
                  <button class="btn btn-outline-success w-100 mt-2">{{items.alias}}</button>
                </router-link>
                <router-link class="w-100" v-if="posts.stid !=3 && posts.onay===0 && posts.sdid===4" :to="items.rote + `${posts.cid*8589}`">
                  <button class="btn btn-outline-success w-100 mt-2">{{items.alias}}</button>
                </router-link>
              </div>

              <button v-if="posts.onay===1 && posts.sdid===4 && $helper.sayfayetki(227736)" class="btn btn-info w-100 mt-3">Onaylı</button>
              <button v-if="posts.onay===0 && posts.sdid===4 && $helper.sayfayetki(227736)" @click="onChange(sid)" class="btn btn-danger w-100 mt-3">ONAYLA</button>
            
            </div>
        </div>
      </div>  
    </section>

    <div v-if="progres.inprogres" class="loading"><img src="/set/ajax-loader.gif"/></div>
  </div>
</template>

<script>
import { decode } from 'js-base64';

export default {

   created() {
     this.progres.inprogres=true
     this.yetki();
     //alert(new Date(Date.now()))
  },
    mounted() {
    //this.mapData();
  },
  data () {
    return {
paths: [
      [ {lat: 1.380, lng: 103.800}, {lat:1.380, lng: 103.810}, {lat: 1.390, lng: 103.810}, {lat: 1.390, lng: 103.800} ]
      ],      
      iconUrl:'https://www.google.com/intl/en_us/mapfiles/ms/micons/',
      harita:false,
        center: {lat:0, lng:0},
        markers: [],
        paths:[],

      logus:{
        saat:'',
        tarih:'',
        kod:3
      },
      fid:'',
      said:'',
      bid:'',
      sid:'', // servis id
      sayfa: 1,
      url : this.$route.params.id,
      posts : {},
      cari:{},
      kullanici:[],
      malzeme:[],
      error :[],
      st:'',
      donem : this.$request.donem(), //kullanılmıyor
      log:[],
      funcs:[],
      ayar:this.$request.ayar(),
      imageList:[],
      kisa:decode(this.$request.ayar().genel.s),
      progres : {
        mesaj:'Bekleyiniz',
        inprogres:false
      },
      list:[], // stok listesi
      depo:[],
      depoalias:'',
      newpost:{
        depo:'',
        depo_kod:0
      },
      icon:{
        3:'green-dot.png',
        4:'yellow-dot.png',
        100:'blue-dot.png'
      }
      //kid:this.$request.ayar().kid,
     // firma:this.$request.ayar().firmaid,
     // yetkis:this.$request.ayar().ya
      //sirano:''
    }
  },
methods : {

baslat(){

              this.$swal({
              title: 'Onaylıyor musunuz?',
              text:'servis başlatılacak',
              type: 'warning',
              //showCancelButton: true,
              confirmButtonText: 'Evet',
              showCloseButton: true,
              showLoaderOnConfirm: true
            }).then((result) => {

              if (result){
                  this.progres.inprogres=true
                  setTimeout(() => {
                    let islem = {
                      id:this.sid, 
                      sd:3,
                      ptarih:new Date(),
                      psaat:this.$helper.trsaatyazdir(),
                      }
                      this.$request.post("baslat/",islem)
                      .then(response => {
                          let log ={ 
                            servis_id : response.data.id,
                            tarih: response.data.ptarih,
                            saat :response.data.psaat,
                            sd:response.data.sd,
                            kid:this.ayar.kid,
                            islem: 'Servis Başlatıldı...',
                            enlem:0,
                            boylam:0
                          }
                          this.$request.post("servis_log/",log).then(() => {
                            this.posts.sdid = 3
                            this.progres.inprogres=false

                            })

                      })
}, 2000);

              }
            })
},
tamamla(ipt,deg,txt){
                  this.$swal({
              title: 'Onaylıyor musunuz?',
              text: txt+ 'kapatılacak',
              type: 'warning',
              //showCancelButton: true,
              confirmButtonText: 'Evet',
              showCloseButton: true,
              showLoaderOnConfirm: true
            }).then((result) => {

              if (result){

              this.progres.inprogres=true
              let islem = {
              sid:this.sid,
              not:this.posts.servis_notu,
              sd : 4,
              ariza_kodu:this.posts.sn,
              depo:this.newpost.depo,
              ptarih:new Date(),
              psaat:this.$helper.trsaatyazdir(),
              iptal:ipt,
              degisim:deg
              }
              this.$request.post("tamamla/",islem)
                .then(res => {
                //                     let log ={
                //   servis_id : this.sid,
                //   tarih: res.data.ptarih,
                //   saat :res.data.psaat,
                //   sd:4,
                //   kid:this.ayar.kid,
                //   islem: 'Servis Tamamlandı',
                //   enlem:response.lat,
                //   boylam:response.long
                // }
                       this.progres.inprogres=false
                })
            }

            })
},
deposec(event,durum){
        var depo = null
        //this.progres.inprogres = true
        if (durum){
            depo = event.target.value.split("#")
        }
        else{
         depo = event.split("#")
        }
                this.newpost.depo = depo[1]
                this.newpost.depo_kod = depo[0]
                this.$request.get("stoklar/"+depo[0]+"/"+this.kisa)
                .then(res => {
                  res.forEach(element => {
                    if (element.adet>0){
                      this.list.push({
                        sto_kod:element.sto_kod,
                        sto_isim:element.sto_isim,
                        adet:element.adet,
                        fiyat:element.fiyat,
                        adet2:0
                      })
                    }
 
                  });
                this.progres.inprogres = false
                })
                .catch(err=>{console.log(err.message+" Mikro Sunucu hatası")})
},
depogetir(){ // mikro depo bağlantı
      
      this.progres.inprogres = true
        this.sayfa=3
        this.deposec('1#Merkez depo',false)
       // this.deposec(this.posts.depo_kod,false)
        this.$request.get("depoliste/"+this.kisa)
         .then(res => {this.depo = res;
            this.progres.inprogres = false})
         .catch(err=>{err.message})
},    

ekle(index){
  this.progres.inprogres = true
          let data = {
             sid:this.sid,
             stid:this.list[index].sto_kod,
             adet:this.list[index].adet2,
             kid:this.ayar.kid,
             depo:this.newpost.depo,
             isim:this.list[index].sto_isim,
             mikrofiyat:this.list[index].fiyat,
             depokod:this.newpost.depo_kod
          }
           this.$request.post("sepet/",data)
           .then(res => {
              this.$request.get("stok_hareketmikro/"+this.sid)
              .then(res => {
                this.malzeme = res.results
                this.progres.inprogres = false
              })
           })
},

onKeyup(arg){
  if(arg.ctrlKey && arg.keyCode == 13){
    let data = {
    saat:this.posts.psaat,
    tarih:this.posts.ptarih,
    not:this.posts.servis_notu,
    id:this.sid
    }
   this.$request.post("saatdegistir/",data)
   .then(res => {
     alert("Değişim Başarılı")
   })
   .catch(err => {
     alert(err)
   })
  }
},
sipBaslat(){
  return new Promise ((resolve,reject) => {
  this.$request.get('mikro/evraksira/'+this.kisa)
  .then(res => { 
    resolve(res[0].sirano)
    })
   .catch(err => {alert(err)})
   })
},
sipekle(){
            this.$swal({
              title: 'Onaylıyor musunuz?',
              text: 'İrsaliye Kayıt yapılacak',
              type: 'warning',
              //showCancelButton: true,
              confirmButtonText: 'Evet',
              showCloseButton: true,
              showLoaderOnConfirm: true
            }).then((result) => {
            this.progres.inprogres=true
            this.sipBaslat()
           .then(res => {
             var process = 0
            this.malzeme.forEach((element,i) => {
              
              setTimeout(() => {
                this.sipkayit(
                  {
                  tarih:new Date(),
                  sira:res,
                  satir:i,
                // ckod:"SAT.0010",//this.cari.kodu,
                   ckod:this.cari.kodu,
                  skod:element.stid, // stok kodu
                  pkod:element.kid,
                  dkod:element.depokod,
                  fiyat:(element.mikrofiyat).toFixed(2).replace(",","."),
                  adet:element.adet,
                  aratoplam:(element.adet * element.mikrofiyat).toFixed(2).replace(",","."),
                  iskonto:0,
                  kdvt:4,//element.kdvt,
                  kdv:0,
                  kisa:this.kisa
                  //guid:element.guid
                  }
                ).then(res=>
                  {
                      process++
                      if(process === this.malzeme.length) {
                         this.$swal('Tebrikler', 'İrsaliye başarı ile oluşturuldu', 'success')
                         this.progres.inprogres=false
                  }
                  }
                )
                .catch(err => {this.$swal(err)})
               }, 500);

            });
           })
           .catch(err => {this.$swal(err)})

      })
},
sipkayit(obje){
        return new Promise ((resolve,reject) => {
         this.$request.post('mikro/sipekle',obje)
          .then(res => {
            resolve(res)
          })
          .catch(err => {reject(err)})
        })
},
yetki: function(){
        if (this.$helper.sayfayetki(691274)){
        let res = this.url.split('sd');

        let sol = res[0].split('bn');
        this.fid = sol[0]/8848;
        this.said = sol[1]/8847;

        let sag = res[1].split('bn');
        this.bid = sag[0]/8846;
        this.sid = sag[1]/8589;

        let baslat = false;
          let table ='';
            if (this.ayar.ya=='sid'){
                table = 'servis'
                baslat = true
                this.getPostsAsync(this.sid,table,baslat)
            }
            else{
                table = 'kayit'
                baslat=true
                this.getPostsAsync(this.sid,table,baslat)
            }
          }
          else {
            alert('Bu alanı kullanım yetkiniz yok')
            this.$router.go(-1)
          }
          this.evrak();
},
        getPostsAsync (sid,table,baslat){
          if (baslat){
          this.$request.get("detay/servis/"+this.ayar.ya+"/"+this.ayar.kid+'/'+sid+'/'+table)
          .then( res => {
            this.posts=res.servis
              this.$request.get("log/"+sid)
              .then(res => {this.log = res.results;
                this.$request.get("cari/"+this.posts.carid)
                .then(res => {
                  this.cari = res.cari
                    this.$request.get("serviskullanici/"+this.sid)
                    .then(res => {this.kullanici = res.results
                      this.$request.get("stok_hareketmikro/"+this.sid)
                      .then(res => {
                        this.malzeme = res.results
                          this.$request.get("stler/"+this.posts.stid)
                           .then(res => {this.funcs=res.results
                             this.mapData();
                           })
                      })
                    })
                })
              })
          })
          .catch(err => {this.error.push(err)})
          }
        },
        mapData(){

         var pros = 0
          this.log.forEach(element => {
            if (element.kod === 3 || element.kod === 100 || (element.kod === 4 && element.islem === "Servis Tamamlandı")){
                this.markers.push({
                    position: {
                      lat: parseFloat(element.enlem), 
                      lng: parseFloat(element.boylam),
                    },
                    icon:'https://www.google.com/intl/en_us/mapfiles/ms/micons/'+this.icon[element.kod],
                    label:element.islem
                })
                
            }
            pros++
          });
          if (pros === this.log.length){
            this.paths = this.markers
          this.progres.inprogres=false
          if (this.cari.enlem && this.cari.boylam){
          this.center.lat = parseFloat(this.cari.boylam)
          this.center.lng = parseFloat(this.cari.enlem)
          }
          else{
          this.center.lat = parseFloat(this.marker[0].position.lat)
          this.center.lng = parseFloat(this.marker[0].position.lng)
          }

          
                    this.markers.push({
                    position: {
                      lat: parseFloat(this.center.lat), 
                      lng: parseFloat(this.center.lng),
                    },
                    icon:'https://www.google.com/intl/en_us/mapfiles/ms/micons/red-dot.png',
                    label:'Merkez'
                })
                this.harita = true 
          }

        },
        onChange(sid) {
            this.$swal({
              title: 'Onaylıyor musunuz?',
              text: 'Servisi Onaylıyorum...',
              type: 'warning',
              //showCancelButton: true,
              confirmButtonText: 'Evet',
              showCloseButton: true,
              showLoaderOnConfirm: true
            }).then((result) => {
              if(result.value) {
                this.progres.inprogres=true
                let islem = {
                  id:sid,
                  sd : 4,
                  onay:1
                }
                  this.$request.post("onay/",islem)
                  .then(res => {
                      let log ={
                        servis_id : res.data.id,
                        tarih: new Date(),
                        saat :this.$helper.trsaatyazdir(),
                        sd:res.data.sd,
                        kid:this.ayar.kid,
                        islem: 'Servis Onaylandı...'
                      }
                      this.$request.post("servis_log/",log)
                        .then(res => {
                            this.$swal('Lütfen Bekleyiniz', 'Servis Onaylandı')
                            this.progres.inprogres=false
                            if (this.malzeme.length>0){
                            setTimeout(() => {
                                this.sipekle();
                            }, 3000);
                          }
                        })
                        .catch(this.$swal('Cancelled', 'Log Kaydı Yapılamadı', 'danger'))
                  })
                  .catch(this.$swal('Cancelled', 'Hata ile karşılaşıldı', 'danger'))
              }
            })
        },
        evrak(){
        this.imageList = []
            this.$request.get("matbuu/"+this.sid)
            .then(res => {
              res.results.forEach(element => {
                  this.imageList.push(
                    {
                      urlsi:this.$request.domain+element.image,
                      id:element.id
                    }
                  )
              });      
            })
            .catch(err=>{})
      },
        kaldir(stid,adet,isim) {
            this.$swal({
              title: 'Onaylıyor musunuz?',
              text: 'Malzeme Silinecek...',
              type: 'warning',
              //showCancelButton: true,
              confirmButtonText: 'Evet',
              showCloseButton: true,
              showLoaderOnConfirm: true
            })
            .then((result) => {
if(result.value) {
               this.progres.inprogres=true

            this.$request.get("sepet/delete/"+this.sid+"/"+stid)
            .then(() => {
              //this.$swal('Cancelled', 'Log Kaydı Yapılamadı', 'danger')
              this.sepetgetir()
                this.progres.inprogres=false
              })
            }
              })
              .catch(res => {alert(err)})
        }, 
        sepetgetir(){
          this.$request.get("stok_hareketmikro/"+this.sid)
           .then(res => { this.malzeme = res.results })
        },
        evraksil(id){
            this.$swal({
              title: 'Onaylıyor musunuz?',
              text: 'Foto Silinecek...',
              type: 'warning',
              //showCancelButton: true,
              confirmButtonText: 'Evet',
              showCloseButton: true,
              showLoaderOnConfirm: true
            })

            .then((result) => {
              if(result.value) {
               this.progres.inprogres=true
                this.$request.get("silevrak/"+id)
                .then(() => {
              //this.$swal('Cancelled', 'Evrak Silindi', 'danger')
                  this.evrak();
                this.progres.inprogres=false
              })
              }
              })

              .catch(res => {alert(err)})          
        },
previewFiles(event) {
  this.progres.inprogres = true
  let data = {image:event.target.files}
  this.$request.post("upload",data)
  .then(res => {
    if (res.success){
          let data = {
             id:this.sid,
             image:res.url
           }
           this.$request.post("matbuu",data)
           .then(res => {
              this.$swal("Foto Yükleme Başarılı")
              this.evrak()
              this.progres.inprogres=false

           })  
    }
    
  })
  //.catch(err => {alert(err)})
    //  console.log(event.target.files);
   },
baslangicsaati(){
  Object.assign(this.logus,{sid:this.sid})
  this.$request.post('logsaatdegistir/',this.logus)
  .then(()=>{
    alert("Başarılı")
  })
  .catch((err)=>{
    alert(err.message)
  })
}       
     }
   }
</script>


// WEBPACK FOOTER //
// src/views/servis/detay.vue